<script setup lang="ts">
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})
const currentImage = ref(0)
const items = ref<{ id: number }[]>(props.items as any)

watch(() => props.items, () => {
  currentImage.value = 0
})

const nextImageId = computed(() => {
  if (currentImage.value === (props.items.length - 1))
    return 0
  else return currentImage.value + 1
})

const previousImageId = computed(() => {
  if (currentImage.value === 0)
    return props.items.length - 1
  else return currentImage.value - 1
})

const nextItem = computed(() => {
  if (currentImage.value === (items.value.length - 1))
    return items.value[0]
  else return items.value[currentImage.value + 1]
})

const previousItem = computed(() => {
  if (currentImage.value === 0)
    return items.value[items.value.length - 1]
  else return items.value[currentImage.value - 1]
})
function previousImage() {
  const nextImage = document.querySelector(`#product-image-${previousItem.value.id}-${previousImageId.value + 1}`)
  nextImage?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
  currentImage.value = previousImageId.value
}

function nextImage() {
  const nextImage = document.querySelector(`#product-image-${nextItem.value.id}-${nextImageId.value + 1}`)
  nextImage?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
  currentImage.value = nextImageId.value
}

function _goToImage(imageNumber: number) {
  const nextImage = document.querySelector(`#product-image-${imageNumber + 1}`)
  nextImage?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
  currentImage.value = imageNumber
}
</script>

<template>
  <div class="w-full">
    <div class="flex justify-between w-full items-center mb-8 px-4">
      <div class="title">
        <slot name="title" />
      </div>
    </div>
  </div>

  <div class="flex items-center gap-4 justify-between bg-white z-20 w-full">
    <button
      class="z-99 bg-primary shadow-input flex-center flex h-10 w-10 p-1 transform cursor-pointer rounded-xl text-white duration-300 hover:scale-105"
      @click="previousImage"
    >
      <span class="i-mdi-chevron-left h-full w-full" />
    </button>

    <div v-auto-animate class="pt-1 bg-white flex items-center overflow-auto w-full snap-x snap-mandatory">
      <div
        v-for="(item, index) in items"
        :id="`product-image-${item.id}-${index + 1}`"
        :key="item.id"
        class="flex-center flex w-20 p-2 md:basis-1/2 basis-full lg:basis-1/3 xl:basis-1/5 flex-none snap-start"
      >
        <slot name="item" :item="item" :index="index" :is-highlighted="index === currentImage" />
      </div>
    </div>
    <button
      class="z-99 bg-primary shadow-input flex-center flex h-10 w-10 p-1 transform cursor-pointer rounded-xl text-white duration-300 hover:scale-105"
      @click="nextImage"
    >
      <span class="i-mdi-chevron-right h-full w-full" />
    </button>
  </div>
</template>

<style scoped>
  .title-font {
  font-family: interstate, sans-serif;
  font-style: normal;
 }
.carrousel-animation-previous {
  animation: moveCarrouselPrevious 0.5s;
}

@keyframes moveCarrouselPrevious {
  0%   {opacity: 1; transform: translateX(0px);}
  20%   {opacity: 0; transform: translateX(20px);}
  80%   {opacity: 0; transform: translateX(-20px);}
  100%   {opacity: 1; transform: translateX(0px);}
}

.carrousel-animation-next {
  animation: moveCarrouselNext 0.5s;
}

@keyframes moveCarrouselNext{
  0%   {opacity: 1; transform: translateX(0px);}
  20%   {opacity: 0; transform: translateX(-20px);}
  80%   {opacity: 0; transform: translateX(20px);}
  100%   {opacity: 1; transform: translateX(0px);}
}
</style>
